import React, { Fragment, useContext, useEffect } from 'react';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Radio from "@material-ui/core/Radio";
import Grid from "@material-ui/core/Grid";
import CheckIcon from '@material-ui/icons/Check';
import Button from "@material-ui/core/Button";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import {InvitesContext} from "../context/InvitesContext";
import { useStyles } from './InviteTemplateStyles.js';

export default function InviteTemplate(props) {
  const { classes, nextStep, setInviteTemplateIsSelected } = props;
  const websitePath = `${process.env.REACT_APP_BACKEND_BASE_URL}/themes/belleevent/`;
  const inviteClasses = useStyles();
  const invitesContext = useContext(InvitesContext);
  const selectedInviteCode = invitesContext.state.invite.selectedInvite;
  const handleChange = (id, code) => {
      return () => {
          invitesContext.dispatch({ type: "CHANGE_VALUE", name: 'selectedInvite', value: code});
          invitesContext.dispatch({ type: "CHANGE_VALUE", name: 'selectedInviteId', value: id });
      }
  }
  // if invite template code in url dispatch invite code and id and skip to step 2
  const inviteCodeFromUrl = window.location.pathname.replace('/creeaza-invitatie/', '').replace('/', '');
  useEffect(() => {
    const fetchInviteTemplateCode = async () => {
      if (inviteCodeFromUrl && !invitesContext.state.invite.selectedInvite) {
        const inviteDetails = invitesContext.state.inviteTemplates.find(invite => invite.code === inviteCodeFromUrl);
        if(inviteDetails) {
          invitesContext.dispatch({ type: "CHANGE_VALUE", name: 'selectedInvite', value: inviteDetails.code});
          invitesContext.dispatch({ type: "CHANGE_VALUE", name: 'selectedInviteId', value: inviteDetails.id });
          nextStep()
        }
      }
    }
    fetchInviteTemplateCode();
  }, [inviteCodeFromUrl, invitesContext, nextStep]);

  useEffect(() => {
    if (selectedInviteCode) {
      setInviteTemplateIsSelected(true)
    }
  }, [selectedInviteCode, setInviteTemplateIsSelected]);

  return (
    <Fragment>
      <Grid container spacing={2} noValidate>
        <Grid item xs={12} className={`${classes.noPadding} ${inviteClasses.invitesContainer}`}>
            <FormControl>
              <FormGroup row className={inviteClasses.invites}>
                {invitesContext.state.inviteTemplates.map(({id, code, thumbnail_path}) => (
                  <Fragment key={code}>
                    <FormControlLabel
                      className={inviteClasses.inviteContainer}
                      key={id}
                      control={
                        <Radio
                          className={inviteClasses.hideRadio}
                          name="selectedInvite"
                          checked={invitesContext.state.invite.selectedInvite === code}
                          onChange={handleChange(id, code)}
                          value={code}
                          key={id}
                          color="primary"
                        />
                      }
                      label={
                        <>
                          <img 
                            src={websitePath + thumbnail_path}
                            alt={invitesContext.state.invite.selectedInvite}
                            className={inviteClasses.inviteImg}
                          />
                          { code === selectedInviteCode &&
                            <div className={inviteClasses.overlayContainer}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={nextStep}
                                className={inviteClasses.continueBtn}
                                >
                                CONTINUĂ <ChevronRightIcon/>
                              </Button>
                              <span className={inviteClasses.overlayIcon}><CheckIcon /></span>
                            </div>
                          }
                        </>
                      }
                    />
                  </Fragment>
                ))}
              </FormGroup>
            </FormControl>
          </Grid>
      </Grid>
    </Fragment>
  )
}